"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Search = exports.classNames = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _shortcut = require("@storybook/api/shortcut");

var _theming = require("@storybook/theming");

var _designSystem = require("@storybook/design-system");

var _react2 = require("@docsearch/react");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var algoliaDocSearchConfig = {
  appId: '6L6UWBTLCK',
  indexName: 'storybook-js'
};
var Wrapper = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "ewskilp3"
} : {
  target: "ewskilp3",
  label: "Wrapper"
})("position:relative;", function (props) {
  return /*#__PURE__*/(0, _theming.css)("--search-button-border:", props.inverse ? 'rgba(255, 255, 255, 0.2)' : _designSystem.styles.color.border, ";--search-button-color:", props.inverse ? _designSystem.styles.color.lightest : _designSystem.styles.color.dark, ";--search-keys-bg:", props.inverse ? 'rgba(0, 0, 0, 0.1)' : 'rgba(0, 0, 0, 0.05)', ";--search-keys-color:", props.inverse ? _designSystem.styles.color.lightest : _designSystem.styles.color.dark, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Wrapper;"));
}, ";");
var Placeholder = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "ewskilp2"
} : {
  target: "ewskilp2",
  label: "Placeholder"
})(process.env.NODE_ENV === "production" ? {
  name: "3pd8qa",
  styles: "flex:none;margin-right:0"
} : {
  name: "3pd8qa",
  styles: "flex:none;margin-right:0",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var classNames = {
  BUTTON: '.DocSearch-Button',
  ICON: '.DocSearch-Button .DocSearch-Search-Icon',
  PLACEHOLDER: '.DocSearch-Button-Placeholder'
};
exports.classNames = classNames;
var idleButtonStyles = process.env.NODE_ENV === "production" ? {
  name: "12j7jkm",
  styles: "background:transparent;box-shadow:var(--search-button-border) 0 0 0 1px inset;color:var(--search-button-color);height:32px"
} : {
  name: "1mjyplh-idleButtonStyles",
  styles: "background:transparent;box-shadow:var(--search-button-border) 0 0 0 1px inset;color:var(--search-button-color);height:32px;label:idleButtonStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var keyStyles = process.env.NODE_ENV === "production" ? {
  name: "il44a1",
  styles: "align-items:center;background:none;box-shadow:none;color:var(--search-keys-color);display:inline-flex;font-family:inherit;font-size:10px;line-height:10px;justify-content:center;padding:0;user-select:none;width:auto"
} : {
  name: "14243mi-keyStyles",
  styles: "align-items:center;background:none;box-shadow:none;color:var(--search-keys-color);display:inline-flex;font-family:inherit;font-size:10px;line-height:10px;justify-content:center;padding:0;user-select:none;width:auto;label:keyStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var Keys = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "ewskilp1"
} : {
  target: "ewskilp1",
  label: "Keys"
})(process.env.NODE_ENV === "production" ? {
  name: "1j3u5t7",
  styles: "pointer-events:none;position:absolute;right:16px;top:50%;transform:translateY(-8px);background:var(--search-keys-bg);border-radius:2px;display:flex;align-items:center;padding:3px 6px"
} : {
  name: "1j3u5t7",
  styles: "pointer-events:none;position:absolute;right:16px;top:50%;transform:translateY(-8px);background:var(--search-keys-bg);border-radius:2px;display:flex;align-items:center;padding:3px 6px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var Key = (0, _theming.styled)("kbd", process.env.NODE_ENV === "production" ? {
  target: "ewskilp0"
} : {
  target: "ewskilp0",
  label: "Key"
})(keyStyles, ";"); // Designed to match Input from @storybook/design-system

var docSearchStyles = /*#__PURE__*/(0, _theming.css)(":root{--docsearch-primary-color:", _designSystem.styles.color.secondary, ";--docsearch-muted-color:", _designSystem.styles.color.dark, ";}", classNames.BUTTON, "{", idleButtonStyles, " font-size:13px;line-height:18px;margin:0;padding:7px 59px 7px 12px;width:100%;&:focus,&:focus:hover{", idleButtonStyles, " box-shadow:", _designSystem.styles.color.secondary, " 0 0 0 1px inset;}&:hover{", idleButtonStyles, ";}}", classNames.ICON, "{color:currentColor;height:12px;margin-right:6px;width:12px;}", classNames.PLACEHOLDER, "{font-size:1em;white-space:nowrap;padding:0;display:block;}.DocSearch-Button-Keys{display:none;}.DocSearch-Commands-Key{", keyStyles, ";}.DocSearch-Label{margin-left:2px;}" + (process.env.NODE_ENV === "production" ? "" : ";label:docSearchStyles;"));

var Shortcut = function Shortcut(_ref) {
  var keys = _ref.keys;
  return /*#__PURE__*/_react["default"].createElement(Keys, null, keys.map(function (key, index) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      _react["default"].createElement(Key, {
        key: index
      }, (0, _shortcut.shortcutToHumanString)([key]))
    );
  }));
};

var label = 'Search docs';

var Search = function Search(_ref2) {
  var version = _ref2.version,
      inverse = _ref2.inverse,
      className = _ref2.className,
      apiKey = _ref2.apiKey;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_theming.Global, {
    styles: docSearchStyles
  }), apiKey ? /*#__PURE__*/_react["default"].createElement(Wrapper, {
    className: className,
    inverse: inverse
  }, /*#__PURE__*/_react["default"].createElement(_react2.DocSearch, (0, _extends2["default"])({
    apiKey: apiKey
  }, algoliaDocSearchConfig, {
    placeholder: label,
    searchParameters: {
      // prettier-ignore
      facetFilters: [
      /*
          Used to allow recipes to come through global search
          along with docs. Values inside an array act as an OR
          between the containing values
      */
      ["tags:docs", "tags:recipes"], ["version:".concat(version), "version:agnostic"]]
    },
    translations: {
      button: {
        buttonAriaLabel: label,
        buttonText: label
      }
    }
  })), /*#__PURE__*/_react["default"].createElement(Shortcut, {
    keys: [(0, _shortcut.controlOrMetaKey)(), 'K']
  })) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Placeholder, {
    className: className
  })));
};

exports.Search = Search;